import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { Clinic, CreateClinic, UpdateClinic } from '@magnetar/admin-api-interfaces'
import type { ClinicDeletionImpact } from '@/pages/clinic/clinicDeletion'

export const clinicService = {
  createClinic: async (data: CreateClinic, token: string) => {
    try {
      const response = await apiClient.post<{ success: boolean; data: Clinic }>(
        '/api/clinics',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  updateClinic: async (clinicId: number, data: UpdateClinic, token: string) => {
    try {
      const response = await apiClient.put<{ success: boolean; data: Clinic }>(
        `/api/clinics/${clinicId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  // 預覽連鎖刪除的影響（不寫入）。回傳 { success, data: ClinicDeletionImpact }。
  getClinicDeletionImpact: async (clinicId: number, token: string) => {
    try {
      const response = await apiClient.get<{ success: boolean; data: ClinicDeletionImpact }>(
        `/api/clinics/${clinicId}/deletion-impact`,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return { success: false }
    }
  },

  // 連鎖刪除診所。必須帶 confirm:true（後端不確認不刪）。
  deleteClinic: async (clinicId: number, token: string) => {
    try {
      const response = await apiClient.delete(`/api/clinics/${clinicId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { confirm: true },
      })

      return response.data || { success: true }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },
}
